export const isomorphicConfig = () => {
  if (!global.clConfig) {
    throw new Error('Config is not available during initial parsing');
  }
  return global.clConfig;
};
